import { render, staticRenderFns } from "./yi-goods-list.vue?vue&type=template&id=62b74775&scoped=true&"
import script from "./yi-goods-list.vue?vue&type=script&lang=js&"
export * from "./yi-goods-list.vue?vue&type=script&lang=js&"
import style0 from "./yi-goods-list.vue?vue&type=style&index=0&id=62b74775&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b74775",
  null
  
)

component.options.__file = "src/components/yi-goods-list/yi-goods-list.vue"
export default component.exports